import { localization } from './cron-localization';
export const genSessionId = () => `${Date.now()}_${Math.random()}`;
export const genClassName = (cssClassPrefix = '', classes, noPrefixClasses = []) => {
    const prefixed = classes.map(c => cssClassPrefix + c);
    return prefixed.concat(noPrefixClasses).join(' ');
};
export const genId = (mode, session, extra) => {
    return `${mode}-${extra || ''}${session}`;
};
export const getCssClassPrefix = (cssClassPrefix) => cssClassPrefix || '';
export const localizeList = (list, localizationStore) => {
    return list.map(v => (Object.assign(Object.assign({}, v), { label: localizeLabel(v.label, localizationStore) })));
};
export const localizeLabel = (label, localizationStore) => {
    return localizationStore[label.toLowerCase()];
};
export const getLocalization = (input) => {
    const args = [localization];
    if (input) {
        args.push(input);
    }
    return mergeDeep(...args);
};
const mergeDeep = (...objects) => {
    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach(key => {
            const pVal = prev[key];
            const oVal = obj[key];
            if (pVal && typeof pVal === 'object' && oVal && typeof oVal === 'object') {
                prev[key] = mergeDeep(pVal, oVal);
            }
            else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, {});
};
